export const WORK_SCHEDULE_APP_STORE_MODULE_NAME = 'app-work-schedule'

export const DEFAULT_EMPLOYEE_TYPE = 'BE'
export const DEFAULT_SCHEDULE_TYPE = 'CURRENT'

export const EMPLOYEE_TYPES = {
  bookers: 'BE',
  sales: 'SE',
}
